export function selectFirstTextColorChange() {
  if (document.querySelector('.js-formSelect')) {
    document.addEventListener('DOMContentLoaded', function () {
      const params = new URLSearchParams(window.location.search);
      const value = params.get('contact_list');
      if (value) {
        var selects = document.querySelectorAll('select[name="contact_list"]');
        selects.forEach(function (select) {
          for (let i = 0; i < select.options.length; i++) {
            if (select.options[i].value === value) {
              select.selectedIndex = i;
              select.style.color = '#000';
              break;
            }
          }
        });
      }
    });

    const formSelectEleAll = document.querySelectorAll('.js-formSelect select');

    formSelectEleAll.forEach((target) => {
      target.addEventListener('change', () => {
        console.log(target.value);

        if (target.value == '') {
          target.style.color = '#9a9a9a';
        } else {
          target.style.color = '#000';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 郵便番号入力欄
    var zipInput = document.querySelector('.js-formAddress');
    // 都道府県select
    var preSelect = document.querySelector('.js-formPre');
    // 市区町村以下
    var muniInput = document.querySelector('.js-formMuni');
    // Contact Form 7のform
    var wpcf7Form = document.querySelector('form.wpcf7-form');

    // 郵便番号入力時のイベント
    if (document.querySelector('.js-formAddress')) {
      zipInput.addEventListener('keyup', handleZip);
      zipInput.addEventListener('change', handleZip);
    }

    function handleZip() {
      var val = zipInput.value.replace(/[^0-9]/g, '');
      if (val.length === 7) {
        var url = 'https://yubinbango.github.io/yubinbango-data/data/' + val.substr(0, 3) + '.js';
        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then(function (jsText) {
            // データファイルは var Yubin = {...}; の形式なので、evalでパース
            var data = {};
            eval('data = ' + jsText.match(/{[\s\S]*}/)[0]);
            var address = data[val];
            if (address) {
              var ken = address[0]; // 都道府県
              var city = address[1] + address[2]; // 市区町村以下

              // 都道府県selectのoptionを選択
              for (var i = 0; i < preSelect.options.length; i++) {
                if (preSelect.options[i].text === ken) {
                  preSelect.selectedIndex = i;
                  // changeイベントを手動で発火
                  var event = new Event('change', { bubbles: true });
                  preSelect.dispatchEvent(event);
                  break;
                }
              }

              // 市区町村以下をセット
              muniInput.value = city;
            }
          })
          .catch(function (error) {
            console.error('郵便番号データ取得エラー:', error);
          });
      }
    }

    // フォーム送信時、都道府県selectの値を強制的に再セット
    if (wpcf7Form) {
      wpcf7Form.addEventListener('submit', function () {
        var ken = preSelect.options[preSelect.selectedIndex].value;
        preSelect.value = ken;
      });
    }
  });
}
